/*
export function getFieldError(errors, path) {
  console.log('#', path, errors)
  if (!errors) return null;
  if (typeof errors === "string") return errors; // fallback si jamais
  const parts = path.split(".");
  return parts.reduce((acc, p) => acc?.[p], errors) || null;
}
  */
import { debug } from 'utils';
export function getFieldAnalysis(analysis, tabKey, fieldKey) {
  if (!analysis) return null;
  return analysis?.[tabKey]?.[fieldKey] || null;
}


export function renderFieldAnalysis(fieldAnalysis) {
  if (!fieldAnalysis) return null;

  // analyse simple (string)
  if (typeof fieldAnalysis === "string") {
    return (
      <div className="small text-muted mt-1">
        {fieldAnalysis}
      </div>
    );
  }
  // analyse structurée
  const {
    status = "",
    comment = null,
  } = fieldAnalysis;
  if (comment == null) return null;
  const typeClassMap = {
    accepted: "text-success",
    warning: "text-warning",
    rejected: "text-danger"
  };

  return (
    <em className={`small ms-1 d-inline-block ${typeClassMap[status] || "text-muted"}`}>
      {comment}
    </em>
  );
}
